<template>
  <div class="main" style="overflow:hidden;width:100%;height:100%;background-size:cover;" :style="{backgroundImage: 'url(' + require('@/assets/auto_background.jpg') + ')'}">
    <div class="member_home">
      <router-link to="/home" class="member_home_a" href="/home">
          <ul>
              <li>
                  <el-image fit="cover"  class="member_home_img" :src="require('@/assets/member_home_ico.png')">
                  </el-image>
              </li>
              <li style="color:#323136;font-weight:bold;">
                  会员中心
              </li>
          </ul>
        </router-link>
    </div>
  </div>
</template>

<script>

import request from '../../api/request'
import watermark from 'watermark-dom'

export default {
    name: 'Index',
    head: {
        title: "首页",
        meta:[
            { name: 'description', content: '首页'}
        ],
    },
    data: function() {
        return {
          user:{}
        }
    },
    methods: {
      fetch_user_info() {
          let user_info_resp = request.site_user.userinfo()
          user_info_resp.then((response) => {
              if (response.status == 200 && response.data.code == 0) {
                if (response.data.data != null && response.data.data != undefined) {
                    this.user = response.data.data
                    if (this.user && this.user.userid) {
                        this.$router.push('/order/list')
                    }
                }
            }
          })
      },
      load() {
          try {
              watermark.remove()
          }
          catch (err) {
              console.log()
          }
          this.fetch_user_info()
      },
    },
    created() {
        this.load()
    },
    components: {

    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main {
  margin: 0;
  padding: 0;
}

.member_home {
    background: #FFFFFFAA;
    display: block;
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0;
}

.member_home ul {
    margin: 0; 
    padding: 0;
    margin: 0 auto;
    height: 100%;
    margin-left: 0px auto;
    margin-right: 0px auto;
    margin-top: 15px auto;
    text-align: center;
}

.member_home ul li {
    list-style: none;
    margin: 0 auto;
}
.member_home ul li:first-child {
    height: 60px;
    margin: 0 auto;
    margin-top: 10px;
}

.member_home_img {
    width: 50px;
    height: 50px;
    margin: 0 auto;
}

.member_home_a {
    height: 100%;
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    color: #999;
}

</style>
